import { Avatar } from '@shared-ui/components'
import { cn } from '@shared-ui/utils'
import { HamburgerIcon } from 'shared/assets/icons'
import { AvatarImage } from 'shared/assets/images'
import { AppLogo } from 'shared/ui'
import { LanguageSwitcher } from 'widgets/LanguageSwitcher/LanguageSwitcher'
import { toggleMobileMenu, toggleUserProfileMobileMenu } from '../Sidebar'
import { UserProfileMenu } from '../UserProfileMenu/UserProfileMenu'
import { useHeader } from './hooks'
import { ThemeToggle } from './ThemeToggle'

export const Header = ({ isMenuOpen = false }: { isMenuOpen?: boolean }) => {
    const { isMobile, isTablet, isBigScreen, avatarImg, dispatch } = useHeader()

    return (
        <div className="inline-flex w-full items-center justify-start bg-background-base px-3 py-1 sm:px-8">
            {isMobile || isTablet || !isBigScreen ? (
                <div className="flex w-full flex-row items-center justify-between">
                    <span
                        role="button"
                        onClick={() => dispatch(toggleMobileMenu())}
                    >
                        <HamburgerIcon />
                    </span>
                    <AppLogo className="h-9" />

                    <span
                        role="button"
                        data-user-menu-trigger
                        onClick={() => {
                            dispatch(toggleUserProfileMobileMenu())
                        }}
                        className="outline-none"
                    >
                        <Avatar
                            size="sm"
                            imgSrc={avatarImg ? avatarImg : AvatarImage}
                        />
                    </span>
                </div>
            ) : (
                <div className="flex w-full flex-row items-center justify-between">
                    <div
                        className={cn(
                            'flex h-[65px] shrink-0 items-center px-4 transition-[width] duration-300 ease-in-out motion-reduce:transition-none',
                            isMenuOpen ? 'w-[12.5rem]' : 'w-[118px]'
                        )}
                    >
                        <AppLogo
                            variant={isMenuOpen ? 'full' : 'icon'}
                            className="h-10 max-w-full"
                        />
                    </div>
                    <div className="flex flex-row items-center gap-0">
                        <LanguageSwitcher />
                        <div className="flex items-center gap-5">
                            <ThemeToggle />
                            {/* <NotificationIcon /> */}
                            {isBigScreen && (
                                <UserProfileMenu
                                    userImg={
                                        avatarImg ? avatarImg : AvatarImage
                                    }
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
